export default "__VITE_ASSET__D7zPA2D1__"